import {configureStore} from '@reduxjs/toolkit';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';
import {guestsLegacyActionMapper} from '~/common/fabric/EventGuests/reducers/guests/legacy-reducer';
import {api as cartApi} from '~/CreateFabricInvitation/api/api';
import {api as oneStepApi} from '~/OneStepCreateInvitation/api/api';
import {api as viewInvitationApi} from '~/ViewInvitation/api/api';
import {dataLayerMiddleware} from '~/CreateFabricInvitation/middleware/dataLayerMiddleware';
import {previewTransformMiddleware} from '~/CreateFabricInvitation/middleware/previewTransform';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {rootReducer} from './reducers';

const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(
    cartApi.middleware,
    oneStepApi.middleware,
    viewInvitationApi.middleware,
    guestsApi.middleware,
    dataLayerMiddleware,
    promiseResolverMiddleware,
    previewTransformMiddleware,
    guestsLegacyActionMapper
  );

export const store = configureStore({
  reducer: rootReducer,
  middleware: middlewares,
});
